export default {
      id: "support-usage",
      viewBox: "0 0 106 128",
      url: __webpack_public_path__ + "icons-sprite.03ac376.svg#support-usage",
      toString: function () {
        return this.url;
      }
    }